import {
  AfterViewInit,
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'projects/cupcake/src/app/core/auto-unsubscribe';
import { isObservable } from 'rxjs';
import { SubSink } from 'subsink';
import { MatChipOption } from '@angular/material/chips';

@AutoUnsubscribe()
@Component({
  selector: 'app-formly-wrapper-currency-addons',
  templateUrl: './formly-wrapper-currency-addons.component.html',
  styleUrls: ['./formly-wrapper-currency-addons.component.scss'],
  imports: [MatChipOption],
})
export class FormlyWrapperCurrencyAddonsComponent
  extends FieldWrapper
  implements AfterViewInit, OnInit
{
  subs = new SubSink();

  constructor(private translate: TranslateService) {
    super();
  }

  addonLeftVisible = false;

  currency = '';

  ngOnInit(): void {
    if (isObservable(this.props.currency)) {
      this.subs.sink = this.props.currency.subscribe(s => {
        this.currency = s as string;
        if (this.currency) {
          this.addonLeftVisible = true;
        }
      });
    } else {
      this.currency = this.props.currency;
      if (this.currency) {
        this.addonLeftVisible = true;
      }
    }
  }

  @ViewChild('matPrefix')
  matPrefix!: TemplateRef<any>;

  ngAfterViewInit() {
    if (this.matPrefix) {
      Promise.resolve().then(() => (this.props.prefix = this.matPrefix));
    }
  }
}
